import { createStore, useStore } from 'zustand';

interface DrawerStateStore {
  isOpen: boolean;
  set: (value: boolean) => void;
}

export const drawerState = createStore<DrawerStateStore>((set) => ({
  isOpen: false,
  set: (isOpen: boolean) => {
    set({ isOpen });
  },
}));

export const useDrawerStateStore = () => useStore(drawerState);
